<template>
  <t-text-input
    v-bind="$attrs"
    :hint="format"
    :rules="validationRules"
    :model-value="modelValue"
    type="text"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import TTextInput from "@/components/core/TTextInput.vue";

interface Props {
  format?: string;
  rules?: ((v?: string | number) => boolean | string)[];
  modelValue?: string;
}

const props = withDefaults(defineProps<Props>(), {
  format: "XXXX XXXX XXXX XXXX",
  rules: () => [],
  modelValue: undefined,
});

defineOptions({
  name: "TCardInput",
  inheritAttrs: false,
});

const validationRules = computed((): ((cardNumber?: string | number) => boolean | string)[] => {
  const validateCardNumberFormat = (cardNumber?: string | number): boolean | string => {
    if (!cardNumber) return true;

    const cardStr = cardNumber.toString();
    const regex = /^([0-9]{16})$/g;

    return regex.test(cardStr.replace(/\D/g, "")) || `O número do cartão precisa estar no formato ${props.format}`;
  };

  const validateCardNumber = (cardNumber?: string | number): boolean | string => {
    if (!cardNumber) return true;

    const cardStr = cardNumber.toString();
    const parsedCardNumber = cardStr.replace(/\D/g, "").length != 16;
    return !parsedCardNumber || "Número do cartão inválido";
  };

  return [...props.rules, validateCardNumberFormat, validateCardNumber];
});
</script>
